import clsx from 'clsx';
import { Base } from '../../Base';
import Svg from '../../Svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "StatusIcon-root_194w9",
  "background": "StatusIcon-background_3vtrN",
  "icon": "StatusIcon-icon_2SEqI"
};
const intentToIcon = {
  info: 'infoWire',
  success: 'successWire',
  warning: 'warningWire',
  danger: 'dangerWire',
  progress: 'infoWire',
  unknown: 'questionWire'
};
function StatusIcon({
  intent = 'info',
  className,
  innerRef,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "span",
    grid: true,
    className: clsx(styles.root, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx("svg", {
      height: "50",
      width: "50",
      viewBox: "0 0 50 50",
      className: styles.background,
      children: /*#__PURE__*/_jsx("circle", {
        cx: "25",
        cy: "25",
        r: "25"
      })
    }), /*#__PURE__*/_jsx(Svg, {
      name: intentToIcon[intent],
      theme: intent,
      className: styles.icon
    })]
  });
}
export default StatusIcon;